var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 84,
    r: 4,
    transform: "rotate(-180 84 84)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 84,
    r: 4,
    transform: "rotate(-180 68 84)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 84,
    r: 4,
    transform: "rotate(-180 52 84)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 84,
    r: 4,
    transform: "rotate(-180 36 84)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 84,
    r: 4,
    transform: "rotate(-180 20 84)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 84,
    r: 4,
    transform: "rotate(-180 4 84)",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 68,
    r: 4,
    transform: "rotate(-180 84 68)",
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 4,
    transform: "rotate(-180 68 68)",
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 68,
    r: 4,
    transform: "rotate(-180 52 68)",
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 68,
    r: 4,
    transform: "rotate(-180 36 68)",
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 68,
    r: 4,
    transform: "rotate(-180 20 68)",
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 68,
    r: 4,
    transform: "rotate(-180 4 68)",
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 52,
    r: 4,
    transform: "rotate(-180 84 52)",
    fill: "white"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 52,
    r: 4,
    transform: "rotate(-180 68 52)",
    fill: "white"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 4,
    transform: "rotate(-180 52 52)",
    fill: "white"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 52,
    r: 4,
    transform: "rotate(-180 36 52)",
    fill: "white"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 52,
    r: 4,
    transform: "rotate(-180 20 52)",
    fill: "white"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 52,
    r: 4,
    transform: "rotate(-180 4 52)",
    fill: "white"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 36,
    r: 4,
    transform: "rotate(-180 84 36)",
    fill: "#F3F4F4"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 36,
    r: 4,
    transform: "rotate(-180 68 36)",
    fill: "#F3F4F4"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 36,
    r: 4,
    transform: "rotate(-180 52 36)",
    fill: "#F3F4F4"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 4,
    transform: "rotate(-180 36 36)",
    fill: "white"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 36,
    r: 4,
    transform: "rotate(-180 20 36)",
    fill: "white"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 36,
    r: 4,
    transform: "rotate(-180 4 36)",
    fill: "white"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 20,
    r: 4,
    transform: "rotate(-180 84 20)",
    fill: "#F3F4F4"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 20,
    r: 4,
    transform: "rotate(-180 68 20)",
    fill: "#F3F4F4"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 20,
    r: 4,
    transform: "rotate(-180 52 20)",
    fill: "#F3F4F4"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 20,
    r: 4,
    transform: "rotate(-180 36 20)",
    fill: "white"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 4,
    transform: "rotate(-180 20 20)",
    fill: "white"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 20,
    r: 4,
    transform: "rotate(-180 4 20)",
    fill: "white"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 4,
    r: 4,
    transform: "rotate(-180 84 4)",
    fill: "#F3F4F4"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 4,
    r: 4,
    transform: "rotate(-180 68 4)",
    fill: "#F3F4F4"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 4,
    r: 4,
    transform: "rotate(-180 52 4)",
    fill: "#F3F4F4"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 4,
    r: 4,
    transform: "rotate(-180 36 4)",
    fill: "white"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 4,
    r: 4,
    transform: "rotate(-180 20 4)",
    fill: "white"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "rotate(-180 4 4)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftDots);
export default __webpack_public_path__ + "static/media/left-dots.be4118a7ecfa70f19a0365c2eae2b07d.svg";
export { ForwardRef as ReactComponent };